module.exports = __webpack_public_path__ + "img/spiral-details4.9ed0a553.png";